import styled from 'styled-components';

export const FeedbackButtonContainer = styled.div`
  position: fixed;
  z-index: 1000;
  
  @media (min-width: 600px) {
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }
  
  @media (max-width: 599px) {
    bottom: 24px;
    right: 24px;
  }
`;